import React from 'react';

import { Route } from 'react-router-dom';

import { PERMISSION_KEYS } from 'constants-permissions';
import type { UserType } from 'application-types';

import { hasPermissionOrSuperUser } from 'lane-shared/helpers/hasPermission';
import { InspectionsDashboard } from '../pages/InspectionsDashboard';
import { useInspectionsAdminDashboardFlag } from '../hooks/useInspectionsAdminDashboardFlag';
import { DASHBOARD_PATH } from './useInspectionsNavigation';

type InspectionsChannel = {
  _id: string;
  settings?: {
    hasInspectionsEnabled?: boolean;
  };
};

export function InspectionsRoutes({
  urlPath,
  channel,
  user,
}: {
  urlPath: string;
  channel?: InspectionsChannel;
  user: UserType;
}): JSX.Element | null {
  const inspectionsAdminDashboardFlag = useInspectionsAdminDashboardFlag();

  if (!channel?.settings?.hasInspectionsEnabled) return null;

  const hasDashboardAccess =
    inspectionsAdminDashboardFlag &&
    hasPermissionOrSuperUser(
      user,
      [PERMISSION_KEYS.PERMISSION_INSPECTIONS_COMPLETE],
      channel._id
    );

  return (
    <>
      {hasDashboardAccess && (
        <Route exact path={`${urlPath}/${DASHBOARD_PATH}`}>
          <InspectionsDashboard />
        </Route>
      )}
    </>
  );
}
